import React from "react";
import AboutUs from '../components/AboutUs'
import Features from '../components/Features'
import Work from "../components/Work";
import Benefits from '../components/Benefits'
import Application from '../components/Application'
import Contact from '../components/Contact'
import Footer from "./Footer";


const Layout = ({ children }) => {
    return (
        <>
            {children}
            <AboutUs />
            <Features />
            <Work />
            <Benefits />
            {/* <Application /> */}
            <Contact />
            <Footer />
        </>
    )
}

export default Layout;